module.exports = __webpack_public_path__ + "img/home_gmap_md.17726838.png";